// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__iOSFm","img":"Card_img__KcpMh","content":"Card_content__Z0JY4"};